module.exports = __webpack_public_path__ + "9704305e6fd8184b40d526fca315d200.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.svg?v=1.1.0
// module id = 1021
// module chunks = 0